<template>
  <div class="container animate-target" v-animate-in>
    <div class="title animate-target" v-animate-in>
      Part 5
      <hr/>
    </div>
    <h1 class="animate-target" v-animate-in>{{$route.meta.sub_header}}</h1>

    <router-link to="/section5/5-1" class="btn btn_kerendia animate-target" v-animate-in>Continue</router-link>
  </div>
</template>

<script>
export default {
  name: "s5_index"
}
</script>

<style scoped>
@import "../../assets/css/section5/s5.css";
</style>
